// extracted by mini-css-extract-plugin
export default {"card":"s2-z"};